import { useTranslations } from "next-intl"
import { Button } from "@/components/shared/ui/button";
import Heading from "../Heading";
import { ChildPropsService } from "@/types/paramsTypes";

const HomeTitle: React.FC<ChildPropsService> = ({ id, serviceType, handleServiceType }) => {

    const t = useTranslations("Home")

    return (
        <div id={id} className="flex flex-col gap-9 items-center justify-center">

            <Heading title={t('servicesTypes.title')} subTitle={t("servicesTypes.subTitle")} />

            <div className="flex gap-2 bg-[#F2FDFF] items-center justify-center rounded-full p-1">
                <Button type="submit" className="px-12 rounded-full hover:bg-none "
                    variant={serviceType === 'people' ? 'sub_primary' : 'ghost_two'}
                    onClick={() => handleServiceType('people')}
                >
                    {t("servicesTypes.people")}
                </Button>

                <Button type="submit" className="px-12 rounded-full hover:bg-none "
                    variant={serviceType === 'companies' ? 'sub_primary' : 'ghost_two'}
                    onClick={() => handleServiceType('companies')}
                >
                    {t("servicesTypes.companies")}
                </Button>
            </div>

        </div>
    )
}

export default HomeTitle